import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import * as Models from '../../models/commonModels';
import * as DashboardModels from '../../models/dashboard/dashboard';
import * as DashboardAction from './dashboard.action';
import { DashboardService } from './dashboard.service';
import { saveAs } from 'file-saver';

export interface DashboardStateModel {

  WebPagesList: Models.ResponseList<DashboardModels.WebPageModel>,
  WebPage: Models.Response<DashboardModels.WebPageModel>,

  TyreChange: DashboardModels.TyreChangeObjectModel,

  DownloadTypeList: Models.ResponseList<DashboardModels.DownloadTypeModel>,
  DownloadType: DashboardModels.DownloadTypeObjectModel,

  WebPageTypeList: Models.ResponseList<DashboardModels.WebPageTypeModel>,

  DownloadsList: Models.ResponseList<DashboardModels.DownloadModel>,
  Download: Models.Response<DashboardModels.DownloadModel>,
  }

@State<DashboardStateModel>({
    name: 'dashboardState',
    defaults: {
      WebPagesList: null,
      WebPage : null,
      TyreChange : null,
      DownloadTypeList : null,
      DownloadType : null,
      WebPageTypeList: null,
      DownloadsList: null,
      Download: null
    }
  })

  @Injectable()

  export class DashboardState {

    constructor(
      private helperService: HelperService,
      private DashboardService: DashboardService,
      private bannerService: BannerService
    ) { }


  @Selector()
  static WebPage(state: DashboardStateModel) {
    return state.WebPage;
  }

  @Selector()
  static WebPagesList(state: DashboardStateModel) {
    return state.WebPagesList;
  }

  @Selector()
  static TyreChange(state: DashboardStateModel) {
    return state.TyreChange;
  }

  @Selector()
  static Download(state: DashboardStateModel) {
    return state.Download;
  }

  @Selector()
  static DownloadsList(state: DashboardStateModel) {
    return state.DownloadsList;
  }

  @Selector()
  static DownloadType(state: DashboardStateModel) {
    return state.DownloadType;
  }

  @Selector()
  static DownloadTypeList(state: DashboardStateModel) {
    return state.DownloadTypeList;
  }


  @Selector()
  static WebPageTypeList(state: DashboardStateModel) {
    return state.WebPageTypeList;
  }

  @Action(DashboardAction.GetWebPageList)
  GetWebPageList(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetWebPageList
  ) {


    const errorMessage = 'Błąd pobierania listy strion.';

    this.DashboardService.getWebPageList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            WebPagesList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DashboardAction.GetWebPageList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DashboardAction.GetWebPageActiveList)
  GetWebPageActiveList(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetWebPageList
  ) {


    const errorMessage = 'Błąd pobierania listy aktywnych strion.';

    this.DashboardService.getWebPageActiveList().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            WebPagesList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DashboardAction.GetWebPageActiveList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DashboardAction.SetWebPage)
  SetWebPage(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.SetWebPage
  ) {

    let errorMessage = 'Błąd zapisu strony www.';

    this.DashboardService.setWebPage(action.WebPage).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zmainy strony www zapisane.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            WebPage: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.SetWebPage', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.GetWebPage)
  GetWebPage(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetWebPage
  ) {

    let errorMessage = 'Błąd odczytu strony www.';

    this.DashboardService.getWebPage(action.WebPage).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              WebPage: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.GetWebPage', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.DeleteWebPage)
  DeleteWebPage(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.DeleteWebPage
  ) {

    let errorMessage = 'Błąd usunięcia strony wwww.';

    this.DashboardService.deletetWebPage(action.WebPage).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Strona www usunięta.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            WebPage: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.DeleteWebPage', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.GetWebPageTypeList)
  GetWebPageTypeList(
    context: StateContext<DashboardStateModel>
  ) {
    const errorMessage = 'Błąd pobierania listy typów stron www.';

    this.DashboardService.getWebPageTypeList().subscribe(
      ret => {
        context.setState(
          patch({
            WebPageTypeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('DashboardAction.GetWebPageTypeList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.GetDownloadList)
  GetDownloadList(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetDownloadList
  ) {


    const errorMessage = 'Błąd pobierania listy plików.';

    this.DashboardService.getDownloadList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            DownloadsList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DashboardAction.GetDownloadList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DashboardAction.GetDownloadActiveList)
  GetDownloadActiveList(
    context: StateContext<DashboardStateModel>,
  ) {


    const errorMessage = 'Błąd pobierania listy aktywnych plików.';

    this.DashboardService.getDownloadActiveList().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            DownloadsList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DashboardAction.GetDownloadActiveList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DashboardAction.SetDownload)
  SetDownload(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.SetDownload
  ) {

    let errorMessage = 'Błąd zapisu pliku.';

    this.DashboardService.setDownload(action.Download).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zmaina pliku zapisane.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Download: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.SetDownload', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.GetDownload)
  GetDownload(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetDownload
  ) {

    let errorMessage = 'Błąd odczytu pliku.';

    this.DashboardService.getDownload(action.Download).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Download: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.GetDownload', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.DeleteDownload)
  DeleteDownload(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.DeleteDownload
  ) {

    let errorMessage = 'Błąd usunięcia pliku.';

    this.DashboardService.deletetDownload(action.Download).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Plik usunięty.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Download: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.DeleteDownload', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.SetDownloadDocument)
  SetDownloadDocument(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.SetDownloadDocument
  ) {

    let errorMessage = 'Błąd przesyłania dokumentu.';

    this.DashboardService.setDownloadDocument(action.Inventory, action.File).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dokument zapisany.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Download: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.SetDownloadDocument', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.GetDownloadDocument)
  GetDownloadDocument(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetDownloadDocument
  ) {

    this.bannerService.info('Rozpoczęto pobieranie dokumentu');

    this.DashboardService.getDownloadDocument(action.Inventory).subscribe(
      res => {

        const file = new File([res.body], this.helperService.GetFileNameFromHttpResponse(res), { type: res.headers.get('Content-Type') });

        saveAs(file);
      },
      res => {
        this.bannerService.error(`Błąd pobierania pliku.`);
      },
      () => {
        this.helperService.consoleLog('DashboardAction.GetDownloadDocument');
      }
    );
  }

  @Action(DashboardAction.GetTyreChange)
  GetTyreChange(
      context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetTyreChange
    ) {
      context.setState(
        patch({
          TyreChange: null
        })
      );

      const errorMessage = 'Błąd pobierania danych o wymianach opon.';

    this.DashboardService.getTyreChange().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreChange: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException('DashboardAction.GetTyreChange', error);

        this.bannerService.error(errorMessage);
        });
  }

  @Action(DashboardAction.GetDownloadTypeList)
  GetDownloadTypeList(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetDownloadTypeList
  ) {
    const errorMessage = 'Błąd pobierania listy typów plików.';

    this.DashboardService.getDownloadTypeList().subscribe(
      ret => {
        context.setState(
            patch({
              DownloadTypeList: ret
            }));
      },

      (error) => {
        this.helperService.SaveException('DashboardAction.GetDownloadTypeList', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }


  @Action(DashboardAction.SetDownloadType)
  SetDownloadType(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.SetDownloadType
  ) {
    const errorMessage = 'Błąd zapisu typu pliku.';

    context.setState(
      patch({
        DownloadType: null
      })
    );
    this.DashboardService.setDownloadType(action.DownloadType).subscribe(
      ret => {
        if (action.DownloadType.Item.DownloadTypeId)
          this.bannerService.success('Zmiany w typie pliku zapisano poprawnie.');
        else
          this.bannerService.success('Dodano nowy typ plików.');
        context.setState(
            patch({
              DownloadType: ret
            }));
      },

      (error) => {
        this.helperService.SaveException('DashboardAction.SetDownloadType', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }

  @Action(DashboardAction.GetDownloadType)
  GetDownloadType(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.GetDownloadType
  ) {

    let errorMessage = 'Błąd odczytu typu pliku.';

    this.DashboardService.getDownloadType(action.DownloadType).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              DownloadType: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.GetDownloadType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DashboardAction.DeleteDownloadType)
  DeleteDownloadType(
    context: StateContext<DashboardStateModel>,
    action: DashboardAction.DeleteDownloadType
  ) {

    let errorMessage = 'Błąd usunięcia typu pliku.';

    this.DashboardService.deletetDownloadType(action.DownloadType).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Typ plik usunięty.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            DownloadType: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DashboardAction.DeleteDownloadType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}

